document.addEventListener('click', e => {
  const dropdown = e.target.closest('.Our_comparison_inneritem_right_table_innerlist_new');
  const title = e.target.closest('.Our_comparison_inneritem_right_table_innerlist_title_new');
  const item  = e.target.closest('.Tabs_common_inner_new');

  // Close ALL dropdowns if click is outside
  if (!dropdown) {
    document
      .querySelectorAll('.Our_comparison_inneritem_right_table_innerlist_new.open')
      .forEach(el => el.classList.remove('open'));
    return;
  }

  // Toggle dropdown on title click
  if (title) {
    dropdown.classList.toggle('open');
  }

  // On item click: set text + close dropdown
  if (item) {
    dropdown.querySelector(
      '.Our_comparison_inneritem_right_table_innerlist_title_new span.Our_comparison_inneritem_right_table_innerlist_title_info_new'
    ).textContent = item.textContent.trim();

    dropdown.classList.remove('open');
  }
});
